import { Component} from '@angular/core';

import { QRCodeComponent } from 'angularx-qrcode';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-share',
  imports: [
    QRCodeComponent,
    MatIconModule,
    TranslatePipe,
  ],
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent {
  public url = window.location.origin;
}
